import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseListCtl, ServiceLocatorService } from '@ncs/ncs-lib';

@Component({
  selector: 'app-tasks-list',
  templateUrl: './tasks-list.component.html',
  styleUrls: ['./tasks-list.component.css'],
})
export class TasksListComponent extends BaseListCtl {
  isChecked: boolean = false;

  constructor(
    public override locator: ServiceLocatorService,
    public override route: ActivatedRoute,
  ) {
    super('', locator, route);
    locator.config.getProperty('endpoint.task').then((property: string) => {
      this.initApiEndpoint(property);
      this.form.searchParams['orderBy'] = 'priority';
      this.form.searchParams['asc'] = 'ASC';
      super.search();
    });
  }

  /**
   * Populate data into form
   * @param form
   * @param data
   */
  override populateForm(form: any, data: any) {
    form.id = data.id;
    form.name = data.name;
    form.userId = data.userId;
    form.title = data.title;
    form.description = data.description;
    form.catgoryName = data.catgoryName;
    form.catgoryId = data.catgoryId;
    form.priority = data.priority;
    form.status = data.status;
    form.targetDate = data.targetDate;
    form.targetTime = data.targetTime;
  }

  //-------------------------------------------Change Status-------------------------------------
  /**
   * Change Status of task
   * @param id
   * @param priority
   */
  changeRating(id: any, priority: any) {
    var _self = this;
    this.isChecked = !this.isChecked;
    if (priority === 'NA') {
      _self.form.searchParams['orderBy'] = 'priority';
      _self.form.searchParams['asc'] = 'DESC';
      this.changePriority(id, 'High');
    } else {
      this.changePriority(id, 'NA');
    }
  }

  /**
   * Change Status of task
   * @param id
   * @param status
   */
  changeStatus(id: any, status: any) {
    var _self = this;
    let s =
      status === null || status === undefined || status == 'Completed'
        ? 'Completed'
        : 'Not started';
    let url =
      _self.locator.config.get('endpoint.task') + '/status/' + id + '/' + s;
    this.locator.http.get(url, function (res: any, error: any) {
      if (error) {
        return;
      }
      _self.search();
    });
  }

  /**
   * Change Priority of task
   * @param id
   * @param status
   */
  changePriority(id: any, status: any) {
    var _self = this;
    _self.isChecked = !_self.isChecked;
    let s = status == 'High' ? 'NA' : 'High';
    let url =
      _self.locator.config.get('endpoint.task') + '/priority/' + id + '/' + s;
    _self.locator.http.get(url, function (res: any, error: any) {
      if (error) {
        return;
      }
      _self.search();
    });
  }

  //--------------------------------Search by Buttons-----------------------------------------------
  /**
   * Search Complete
   */
  searchComplete() {
    var _self = this;
    if (_self.form.searchParams['status'] == 'Complete') {
      _self.resetSearchForm();
    } else {
      _self.form.searchParams['status'] = 'Complete';
      _self.search();
    }
  }

  /**
   * Search Not Started
   */
  searchNotStarted() {
    var _self = this;
    if (_self.form.searchParams['status'] == 'Not started') {
      _self.resetSearchForm();
    } else {
      _self.form.searchParams['status'] = 'Not started';
      _self.search();
    }
  }

  /**
   * Search Priority
   */
  searchPriority() {
    var _self = this;
    _self.form.searchParams['status'] = null;
    if (_self.form.searchParams['priority'] == 'High') {
      _self.resetSearchFormParam();
      this.form.searchParams['orderBy'] = 'priority';
      this.form.searchParams['asc'] = 'DESC';
      _self.search();
    } else {
      _self.resetSearchFormParam();
      _self.form.searchParams['priority'] = 'High';
      _self.search();
    }
  }

  /**
   * Reset only Search form
   */
  resetSearchFormParam() {
    this.form.searchError = false;
    this.form.searchMessage = '';
    this.form.searchParams = {};
  }

  //------------------------------------------------------------------------------------------------

  //---------------------------------Change Background colour --------------------------------------

  /**
   * Change bg colour
   * @param status
   * @param targetDate
   * @returns
   */
  // getBackgroundColor(status: string, targetDate: string): string {
  //   const today = new Date();
  //   const target = new Date(targetDate);
  //   if (status === 'Completed') {
  //     return '#2bef1f66'; // Green for completed
  //   } else if (status === 'Not started' || 'null') {
  //     if (target < today) {
  //       return '#f34f5f66'; // Red for past due
  //     } else if (this.isDueTomorrow(targetDate)) {
  //       return '#FFC10766'; // Yellow for due tomorrow
  //     }
  //   }
  //   return '#e3e3e3'; // Default color (none)
  // }

  getBackgroundClass(status: string, targetDate: string): string {
    const today = new Date();
    const target = new Date(targetDate);

    if (status === 'Completed') {
      return 'task-completed';
    }

    if (!status || status === 'Not started') {
      if (target < today) {
        return 'task-overdue';
      } else if (this.isDueTomorrow(targetDate)) {
        return 'task-warning';
      }
    }

    return 'task-default';
  }

  /**
   * Check if target is tomorrow
   * @param targetDate
   * @returns
   */
  isDueTomorrow(targetDate: string): boolean {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1); // Increment by 1 day
    const target = new Date(targetDate);
    return target.toDateString() === tomorrow.toDateString(); // Check if target is tomorrow
  }

  //-----------------------------------------------------------------------------------------------

  /**
   * override the default search function for list null on false response
   * @param callback
   */
  override search(callback?: any) {
    var _self = this;

    _self.form.searchError = false;
    _self.form.searchMessage = '';
    _self.form.list = [];

    this.locator.config
      .getProperty(_self.api.endpoint)
      .then((property: string) => {
        let url = _self.api.search + '/' + _self.form.pageNo;
        _self.form.searchParams['pageSize'] = _self.form.pageSize;

        this.locator.http.post(
          url,
          _self.form.searchParams,
          function (res: any, error: any) {
            if (error) {
              if (callback) {
                callback(error);
              }

              return;
            }

            _self.form.searchError = !res.success;
            _self.form.searchMessage = res.result['message'];

            if (res.success) {
              _self.form.list = res.result.data;
              _self.form.pageCount = res.result.pageCount;
              _self.form.pageSize = res.result.pageSize;
              _self.form.pageNos = _self.form.pageNo;
              _self.form.pageNoList = [];
              //Build page number list
              for (let i = 0; i < _self.form.pageCount; i++) {
                _self.form.pageNoList.push(i);
              }

              //Check empty list
              if (_self.form.list.length == 0) {
                _self.form.message = 'No record found';
                _self.form.error = true;
              }

              // Add data in Datatable
              //_self.initializeDataTable();

              if (callback) {
                callback();
              }
            }

            if (callback) {
              callback();
            }
          },
        );
      });
  }

  //-----------------------------------------------------------------------------------------------

  /**
   * String triming
   * @param value
   * @returns
   */
  transform(value: string): string {
    if (!value) return '';

    // Split the string into hours and minutes
    const [hours, minutes] = value.split(':').map(Number);

    // Create a new Date object
    const date = new Date();
    date.setHours(hours, minutes);

    // Format using toLocaleTimeString
    return date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true, // Ensure 12-hour format with AM/PM
    });
  }

  /**
   * Tool tip title
   * @param field
   * @returns
   */
  getDescription(field: any) {
    if (field['description']) {
      return field['description'];
    }

    return field['label'];
  }

  //-----------------------------------------------------------------------------------------------

  /**
   * Save this.form.data using post method
   */
  override save(callback?: any) {
    var _self = this;

    _self.form.error = false;
    _self.form.message = '';
    _self.form.inputerror = {};

    _self.form.data.status ??= 'Not started';
    _self.form.data.priority ??= 'NA';

    _self.locator.config
      .getProperty('endpoint.task')
      .then((property: string) => {
        _self.locator.http.post(
          property + '/save',
          _self.form.data,
          function (res: any, error: any) {
            if (error) {
              return;
            }

            _self.form.error = !res.success;
            _self.form.message = res.result.message;

            if (res.success) {
              _self.form.message = 'Data is saved';
              _self.populateForm(_self.form.data, res.result.data);
              _self.search();
              // Set a 2-second delay to call clearMessage
              setTimeout(() => {
                _self.clearMessage(_self.form);
              }, 5000);
              _self.clearForm();
              if (callback) {
                callback();
              }
            } else {
              _self.form.inputerror = res.result.inputerror || {};

              // Combine all inputerror messages into one string
              let messages = [];
              for (let key in _self.form.inputerror) {
                if (_self.form.inputerror[key]) {
                  messages.push(_self.form.inputerror[key]);
                }
              }

              // If detailed errors exist, show those. Otherwise show general message.
              _self.form.message =
                messages.length > 0
                  ? messages.join(', ')
                  : res.result.message || res.message || 'Input error';
            }
          },
        );
      });
  }

  clearForm() {
    this.form.data = {};
  }
}
